
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/exhibitors/[project]",
      function () {
        return require("private-next-pages/[locale]/exhibitors/[project].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/exhibitors/[project]"])
      });
    }
  